import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';

export const getAppLocal = ((state: AppState) => state.app);

export const getLocale = createSelector([getAppLocal], (appLocal) => appLocal.locale);
